import {
  GOOGLE_AUTH,
  GOOGLE_AUTH_ERROR,
  AUTHENTICATION_TRUE,
  AUTHENTICATION_FALSE,
  CREATE_POST_ERROR,
  CREATE_POST_SUCCESS,
  GET_POST_SUCCESS,
  GET_POST_ERROR,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR,
  CLEAR_POST_SUCCESS_ERROR,
  SINGLE_ARTICLE_SUCCESS,
  SINGLE_ARTICLE_ERROR,
  SINGLE_ARTICLE_COMMENTS_SUCCESS,
  SINGLE_ARTICLE_COMMENTS_ERROR,
  SUBMIT_COMMENT_SUCCESS,
  SUBMIT_COMMENT_ERROR,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
  LIKE_ARTICLE_SUCCESS,
  LIKE_ARTICLE_ERROR,
  DISLIKE_ARTICLE_ERROR,
  DISLIKE_ARTICLE_SUCCESS,
  UNFOLLOW_USER_ERROR,
  UNFOLLOW_USER_SUCCESS,
  FOLLOW_USER_ERROR,
  FOLLOW_USER_SUCCESS,
  DELETE_COMMENT_ERROR,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_RESET,
  USER_FEED_SUCCESS,
  USER_FEED_ERROR,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
  USER_LOGOUT,
  GET_POST_AUTHOR_SUCCESS,
  GET_POST_AUTHOR_ERROR,
  USER_POST_SUCCESS,
  USER_POST_ERROR,
  TAG_POST_SUCCESS,
  TAG_POST_ERROR,
} from "./actionTypes";

const initialState = {
  isAuthenticated: false,
  googleAuthError: {},
  user: {},
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case GOOGLE_AUTH:
      return {
        ...state,
        user: action.payload.data.user,
        googleAuthError: {},
      };
    case GOOGLE_AUTH_ERROR:
      return {
        ...state,
        googleAuthError: action.payload,
      };
    case GET_POST_SUCCESS:
      return {
        ...state,
        posts: action.payload.data.articles,
      };
    case GET_POST_ERROR:
      return {
        ...state,
        posts: [],
      };
    case SINGLE_ARTICLE_SUCCESS:
      return {
        ...state,
        singlePost: action.payload.data.article,
      };
    case SINGLE_ARTICLE_ERROR:
      return {
        ...state,
        singlePost: false,
      };
    case SUBMIT_COMMENT_SUCCESS:
      return {
        ...state,
        commentPosted: true,
      };
    case SUBMIT_COMMENT_ERROR:
      return {
        ...state,
        commentPosted: false,
      };
    case USER_UPDATE_SUCCESS:
      return {
        ...state,
        userDetailsUpdated: true,
      };
    case USER_UPDATE_ERROR:
      delete state.userDetailsUpdated;
      return {
        ...state,
      };
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        commentDeleted: true,
      };
    case DELETE_COMMENT_ERROR:
      return {
        ...state,
        commentDeleted: false,
      };
    case DELETE_COMMENT_RESET:
      delete state.commentDeleted;
      return {
        ...state,
      };
    case USER_POST_SUCCESS:
      return {
        ...state,
        userPosts: action.payload.data.articles,
      };
    case USER_POST_ERROR:
      delete state.userPosts;
      return {
        ...state,
      };
    case TAG_POST_SUCCESS:
      return {
        ...state,
        tagPosts: action.payload.data.articles,
      };
    case TAG_POST_ERROR:
      delete state.tagPosts;
      return {
        ...state,
      };
    case SINGLE_ARTICLE_COMMENTS_SUCCESS:
      return {
        ...state,
        singlePostComments: action.payload.data.comments,
      };
    case SINGLE_ARTICLE_COMMENTS_ERROR:
      return {
        ...state,
        singlePostComments: false,
      };
    case USER_FEED_SUCCESS:
      return {
        ...state,
        userFeed: action.payload.data.articles,
      };
    case USER_FEED_ERROR:
      return {
        ...state,
        userFeed: false,
      };
    case GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: action.payload.data.tags,
      };
    case GET_TAGS_ERROR:
      return {
        ...state,
        tags: [],
      };
    case CREATE_POST_SUCCESS:
      return {
        ...state,
        createPost: action.payload.data,
      };
    case CREATE_POST_ERROR:
      return {
        ...state,
        createPost: false,
      };
    case GET_POST_AUTHOR_SUCCESS:
      return {
        ...state,
        postAuthor: action.payload.data,
      };
    case GET_POST_AUTHOR_ERROR:
      delete state.postAuthor;
      return {
        ...state,
      };
    case CLEAR_POST_SUCCESS_ERROR:
      state.createPost && delete state.createPost;
      return {
        ...state,
        // createPost: {},
      };
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.data.user,
      };
    case GET_CURRENT_USER_ERROR:
      return {
        ...state,
        user: {},
      };
    case LIKE_ARTICLE_SUCCESS:
      return {
        ...state,
        articleLiked: true,
      };
    case LIKE_ARTICLE_ERROR:
      delete state.articleLiked;
      return {
        ...state,
        // articleLiked: false,
      };
    case DISLIKE_ARTICLE_SUCCESS:
      return {
        ...state,
        articleLiked: false,
      };
    case DISLIKE_ARTICLE_ERROR:
      delete state.articleLiked;
      return {
        ...state,
        // articleLiked: false,
      };
    case FOLLOW_USER_SUCCESS:
      return {
        ...state,
        userFollowed: true,
      };
    case FOLLOW_USER_ERROR:
      delete state.userFollowed;
      return {
        ...state,
        // articleLiked: false,
      };
    case UNFOLLOW_USER_SUCCESS:
      return {
        ...state,
        userFollowed: false,
      };
    case UNFOLLOW_USER_ERROR:
      delete state.userFollowed;
      return {
        ...state,
        // articleLiked: false,
      };

    // below cases are used in case required
    case AUTHENTICATION_TRUE:
      return {
        ...state,
        isAuthenticated: true,
      };
    case AUTHENTICATION_FALSE:
      return {
        ...state,
        isAuthenticated: false,
      };
    case USER_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return {
        ...state,
      };
  }
}
